import ReactGA4 from 'react-ga4';

interface GaProps {
  pathname: string;
}

export default function GoogleAnalytics(pathname: GaProps['pathname']) {
  ReactGA4.initialize(String(process.env.REACT_APP_GA_KEY));

  let pageView: string;

  if (pathname === '*') pageView = '/not-found';
  else pageView = pathname;

  ReactGA4.send({ hitType: 'pageview', page: pageView, title: pageView });
}
